import React from "react";
import RowOfPostElement from "../elements/row-of-post-element";
import {renderRichText} from "gatsby-source-contentful/rich-text";
import {Link} from "gatsby";

export default function RowOfPostsSection(
        {content, dataProvider, dynamicPosts, categories = null, activeCategory = null}
    ) {
    const renderHeaderByType = () => {
        if (content.splitTitle) {
            return (
                <div className="row align-items-center pb-5">
                    <div className={`col-12 ${content.body ? 'col-md-6' : 'col-md-8'}`}>
                        <h2>{content.title}</h2>
                    </div>
                    {content.body &&
                        <div className={`col-12 ${content.body ? 'col-md-5 offset-md-1' : 'col-md-4'} `}>
                            <div className={'subtitle'}>
                                {renderRichText(content.body)}
                            </div>
                        </div>
                    }
                </div>
            )
        }
        return (
            <div className="header-content row">
                <div className="col-12 col-lg-6 ">
                    <h1>{content.title}</h1>
                    {renderRichText(content.body)}
                </div>
            </div>
        )
    }

    const getDynamicPosts = () => {
        try {
            return dataProvider.raw.allContentfulBlogPost.nodes
        } catch (e) {
            return []
        }
    }

    let elements = content.elements
    if(dynamicPosts) {
        elements = getDynamicPosts()
    }

    if (activeCategory && activeCategory !== 'all') {
        elements = elements.filter((element) => {
            return element.category?.slug === activeCategory
        })
    }

    return (
        <section className="blog" key={content.id}>
            <div className="container">
                { renderHeaderByType() }
                { categories &&
                    <div className='row blog--header'>
                        <div className='col-lg-12'>
                            <ul className='blog-category-list'>
                                <li>
                                    <Link to={`/ecosystem`}
                                          className={`${activeCategory === "all" && "active"}`}>
                                        All
                                    </Link>
                                </li>
                                {categories.map((category, index) => {
                                    return (
                                        <li key={index}>
                                            <Link
                                                to={`/ecosystem/category/${category.slug}`}
                                                className={`${activeCategory === category.slug && "active"}`}
                                            >
                                                {category.title}
                                            </Link>
                                        </li>
                                    );
                                })}
                            </ul>

                            <div className='dropdown blog-category-select'>
                                <button className='btn btn-secondary dropdown-toggle' type='button'
                                        data-bs-toggle='dropdown' aria-expanded='false'>
                                    {activeCategory.toUpperCase()}
                                </button>
                                <ul className='dropdown-menu'>
                                    <li>
                                        <Link className='dropdown-item' to={`/ecosystem/category/all`}>
                                            All
                                        </Link>
                                    </li>
                                    {categories.map((category, index) => {
                                        return (
                                            <li key={index}>
                                                <Link className='dropdown-item'
                                                      to={`/ecosystem/category/${category.slug}`}>
                                                    {category.title}
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                }
                <div className="row blog--container__list center">
                    { elements.map((element, index) => {
                        return (
                            <div className="col-12 col-sm-6 col-lg-4 mb-lg-80" key={index}>
                                <RowOfPostElement content={element} />
                            </div>
                        );
                    }) }
                </div>
            </div>
        </section>
    )
}
